import { MutationTree } from "vuex";
import { AccountState } from "./account.types";

type LocationMutationTree = MutationTree<AccountState>;

export const mutations: LocationMutationTree = {
  setLoading(state: AccountState, loading: boolean) {
    state.loading = loading;
  },

  setAccountData(state: AccountState, data: any) {
    state.accountData = data;
  },

  setLoadingAvailability(state: AccountState, loading: boolean) {
    state.loadingAvailability = loading;
  },

  setAvailability(state: AccountState, data: any) {
    state.availability = data;
  }
};
